module.exports = __webpack_public_path__ + "custom-config/img/kexinwangzhan.fcb135b.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/commons/footer/kexinwangzhan.png
// module id = Uq1x
// module chunks = 2 3 4 6 7 8 9